//@flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import QuestionMarkFilledIcon from 'dibs-vg/dist/react/circle-question-mark-filled';
import { localStorage } from 'dibs-browser-storage';

import styles from './HowPointsWork.scss';

export const DISMISSED_LOCAL_STORAGE_KEY = 'how_points_work_dismissed';

type State = {
    dismissed: boolean,
};

export class HowPointsWork extends React.Component<{}, State> {
    constructor() {
        super();
        const dismissed = localStorage.getItem(DISMISSED_LOCAL_STORAGE_KEY);
        this.state = { dismissed };
    }

    toggleDismissed = () => {
        const updatedDismissedFlag = !this.state.dismissed;
        this.setState(
            {
                dismissed: updatedDismissedFlag,
            },
            () => localStorage.setItem(DISMISSED_LOCAL_STORAGE_KEY, updatedDismissedFlag)
        );
    };

    render() {
        const { dismissed } = this.state;

        return (
            <div className={styles.container}>
                <div className={styles.questionIconContainer}>
                    <div className={styles.questionIconWrapper}>
                        <QuestionMarkFilledIcon className={styles.questionIcon} />
                    </div>
                </div>
                <ExpandingArea
                    dataTn="how-points-work-expanding-area"
                    expanded={!dismissed}
                    label={
                        <FormattedMessage
                            id="abt.rewards.HowPointsWork.label"
                            defaultMessage="how do my points work?"
                        />
                    }
                    labelClass={styles.label}
                    onClick={this.toggleDismissed}
                    showArrow
                    wrapperClass={styles.expandingAreaWrapper}
                >
                    <div className={styles.expandableContent}>
                        <ul className={styles.infoList}>
                            <li className={styles.infoListItem}>
                                <FormattedMessage
                                    id="abt.rewards.HowPointsWork.pointsResetJanuary"
                                    defaultMessage="Points toward your status reset on January 1 each year."
                                />
                            </li>
                            <li className={styles.infoListItem}>
                                <FormattedMessage
                                    id="abt.rewards.HowPointsWork.remainingPoints"
                                    defaultMessage="Remaining points toward your next cash back reward will carry over to 2019 and expire with 12 months of account inactivity."
                                />
                            </li>
                        </ul>
                        <ul className={styles.infoList}>
                            <li className={styles.infoListItem}>
                                <FormattedMessage
                                    id="abt.rewards.HowPointsWork.cantLoseStatusSameYear"
                                    defaultMessage="You can’t lose status in the same year."
                                />
                            </li>
                            <li className={styles.infoListItem}>
                                <FormattedMessage
                                    id="abt.rewards.HowPointsWork.pointsEarnedLastYear"
                                    defaultMessage="The points you earned last year determine your starting status this year--reach a higher tier this year and you'll have it through next year."
                                />
                            </li>
                        </ul>
                    </div>
                </ExpandingArea>
            </div>
        );
    }
}
